import { deleteBiddingIntradayOrder } from '@ebalance/proto/bffuser/v1/bidding_intraday_service-BiddingIntradayService_connectquery'

import { biddingQueryKeys } from '~/hooks/bidding/queryKeys'
import { useWorkflowCaseScopedMutation } from '~/hooks/bidding/useWorkflowCaseScopedMutation'
import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/** 時間前入札の下書き削除 mutation。 */
export function useDeleteBiddingIntradayOrder(): InvalidatingMutationResultFor<
  typeof deleteBiddingIntradayOrder
> {
  return useWorkflowCaseScopedMutation(
    useInvalidatingMutation(deleteBiddingIntradayOrder, [
      biddingQueryKeys.intradayList,
      biddingQueryKeys.intradayDetail,
    ]),
  )
}
